<template>
    <div class="bg-wgn-purple-2 rounded-2xl w-full h-[433px] flex flex-col" style="background-position: center top;background-image: url('/images/ellipse.svg');">
        <div class="h-full"></div>
        <span class="text-white text-3xl font-bold max-w-xs text-center m-auto h-full">Time to convert your project into Web3</span>
        <Link :href="route('contact')" class="px-6 py-2 text-wgn-purple-2 bg-white text-base rounded-[40px] m-auto mb-12">Learn more</Link>
    </div>
</template>
